require('./bootstrap');

import Vue from 'vue';

// Vuex store
import Store from './store.js';

// Vue Router
import Router from './router';

// Offline notification
import VueOffline from 'vue-offline';
Vue.use(VueOffline, {
    mixin: false,
});

// Form validation
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate, {
    classes: true,
});

// Buefy
import '../sass/bulma.scss';
import Buefy from 'buefy';
Vue.use(Buefy, {
    defaultIconPack: 'fas',
    defaultTooltipType: 'is-dark',
});

// Lazy loading images
import VueLazyload from 'vue-lazyload';
Vue.use(VueLazyload);

// Graphs
import Chartkick from 'vue-chartkick';
import Chart from 'chart.js';
Vue.use(Chartkick.use(Chart));

// Sentry error logging
require('./sentry');

// Global variables
Vue.prototype.$meta = window.meta;
Vue.prototype.$minPasswordLength = parseInt(process.env.MIX_MIN_PASSWORD_LENGTH);
Vue.prototype.$maximumRowsToDownload = parseInt(process.env.MIX_MAXIMUM_ROWS_TO_DOWNLOAD, 10);

// Set custom CSS variables
require('./css-filters');

// Vue filters
require('./filters');

// App template
import App from './views/App';

new Vue({
    el: '#app',
    components: {
        App,
    },
    store: Store,
    router: Router,
});
